import { useEffect, useState } from 'react'
import { useTitle } from 'ahooks'
import { callNativeByParams, getOS } from '@penguin/utils'
import styles from './systemMaintenance.module.css'

const INITIAL_COUNTDOWN = 3
const ALIPAY_MINI_PROGRAM_URL = 'alipays://platformapi/startapp?appId=2021006136615166'
const ERROR_IMAGE_URL = 'https://static.qiekj.com/static/web/image/error-icon_1675241970673.png'

const SystemMaintenance = () => {
  const [countdown, setCountdown] = useState(INITIAL_COUNTDOWN)

  useTitle('APP系统维护中')

  useEffect(() => {
    if (countdown === 0) {
      if(getOS() === 'IOS'){
        callNativeByParams('jumpNativePage', {
          url: ALIPAY_MINI_PROGRAM_URL,
        })
        return
      }
      window.location.href = ALIPAY_MINI_PROGRAM_URL
      return
    }

    const timer = window.setTimeout(() => {
      setCountdown((currentCountdown) => currentCountdown - 1)
    }, 1000)

    return () => window.clearTimeout(timer)
  }, [countdown])

  return (
    <main className={styles.page}>
      <div className={styles.content}>
        <img className={styles.image} src={ERROR_IMAGE_URL} alt='' />
        <p className={styles.message}>APP系统维护中，{countdown}s后跳转支付宝小程序下单</p>
      </div>
    </main>
  )
}

export default SystemMaintenance
